import { useEffect } from "react";
import useGuardarPrueba from "./useGuardarPrueba";

/** Registra los datos de una rep. para el guardado conjunto de la prueba. */
export default function useRegistroRep(repKey, getSnapshot, hasData) {
    const { registerRep, unregisterRep } = useGuardarPrueba();

    useEffect(() => {
        if (repKey == null) return undefined;
        registerRep(repKey, getSnapshot, hasData);
        return () => unregisterRep(repKey);
    }, [repKey, registerRep, unregisterRep, getSnapshot, hasData]);
}
